import React, {useEffect, useState} from 'react'
import {Box, FormControl, FormHelperText, Input, InputAdornment, InputLabel, Select as MaterialSelect,TextField,Typography} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import {useHistory} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import {green} from '@material-ui/core/colors';
import ModalTam from '../Generales/ModalTam';
import {toast} from 'react-toastify';
import {ErrorGeneral, llamaApiCargaToken} from '../funciones/ClienteAxios';
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment/moment";
import NumberFormat from 'react-number-format';
import dayjs from "dayjs"; 
import utc from 'dayjs/plugin/utc.js'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex', flexWrap: 'noWrap',  flexDirection: "column" ,//alignItems: 'center',
    }, wrapper: {
        marginTop: 0, paddingTop: 0, position: 'relative',
    },
    buttonGuardar: {color: green[500],}, buttonProgress: {
        color: green[500], position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12,
    },
}));

export default function ModalEditar({ modalAbierto, setModalAbierto,
                                        titulo,  auxRegistro, datos,
                                        setAuxRegistro, setDatos
                                    }) {
    dayjs.extend(utc);   
    let history = useHistory();
    const classes = useStyles();
    const source = axios.CancelToken.source();
    const [aviso, setAviso] = React.useState(false);
    const [mensaje, setMensaje] = React.useState('');
    const [tipoAdvertencia, setTipoAdvertencia] = React.useState('success');
    const [registro, setRegistro] = React.useState({
        Id: 0,        Descr: "",
        UbicId: 0,
        TipoId: 0,
        StatusId: 0,
        CancelMotivo: "",
        FEvento: new Date,
        Titulo:"",
        DetId:0, TVida:0, HUso:0, Vuelta:0,
        Distancia:0, Desgaste:"", EngFCambio:0,
        EngNota:"",  Tecnico:"", txtLeyenda:"", auxTotVidal:0.00,
        colorLeyenda:process.env.REACT_APP_COLOR
    })
    const [espera, setEspera] = React.useState(false);
    const {Id, Descr, UbicId, TipoId, StatusId, CancelMotivo, FEvento,Titulo, DetId, TVida, HUso, Vuelta,
        Distancia, Desgaste, EngFCambio, EngNota,   Tecnico, txtLeyenda, colorLeyenda, auxTotVidal} = registro;
    const [fechas, setFechas] = useState({inicio: new Date, FMtto: new Date});
    const [txtVida, setTxtVida] = useState("")
    const {inicio, FMtto} = fechas

    useEffect(() => {
        //console.log(auxRegistro);
        
        setFechas({inicio:dayjs.utc(auxRegistro.RodFchini).format("YYYY-MM-DDTHH:mm:ss"), 
            FMtto:dayjs.utc(auxRegistro.FMtto).format("YYYY-MM-DDTHH:mm:ss"),} )
        setRegistro({...registro, TVida:auxRegistro.RodTVida, HUso:auxRegistro.RodHuso, Vuelta:auxRegistro.RodVuelta,
            Distancia:auxRegistro.RodDistancia, Desgaste:auxRegistro.RodDesgaste, EngFCambio:auxRegistro.EngFchCambio,
            EngNota:auxRegistro.EngNota,  Tecnico:auxRegistro.Tecnico, txtLeyenda:""
        })
    }, [auxRegistro])

    useEffect(()=>{
        if (HUso.length!==0 && parseInt(HUso) !== 0 ) {
            if (Vuelta.length !==0 && parseInt(Vuelta) !== 0) {
                const auxDistancia= ( (parseFloat(HUso*60)) * parseFloat(Vuelta)) / 100.00
                //console.log(auxVal);
                
                let auxTotVidal=0.00, auxTDesgaste=0.00
                if (auxDistancia ===0.00) {
                    auxTotVidal=auxDistancia
                }
                else{
                    auxTotVidal = ((parseFloat(TVida) - auxDistancia) *1.00).toFixed(2)
                    auxTDesgaste = (auxDistancia /( parseFloat(TVida) )* 100.00).toFixed(2)
                }
                //const auxTxt=`Vida ${auxTotVidal}hrs  Desgaste ${auxTDesgaste}%`
                const auxTxt=`hrs  Desgaste ${auxTDesgaste}%`
                const bgTxt = BGTexto(auxTDesgaste)
                setRegistro({...registro, Distancia: auxDistancia, txtLeyenda:auxTxt, colorLeyenda:bgTxt,
                    auxTotVidal:auxTotVidal
                })
            }
        }
        //console.log(HUso,Vuelta);
        
    },[HUso, Vuelta])

    const BGTexto =(desgaste)=>{
        let color="", bandera=true
        const auxTDesgaste = desgaste /100
        if (bandera && (auxTDesgaste <= 0.25 )) {
            color="#19A11E"
            bandera=false
        }
        if (bandera && (auxTDesgaste >= 0.26 ) && (auxTDesgaste <= 0.50 )) {
            color="#E1AA06"
            bandera=false
        }
        if (bandera && (auxTDesgaste >= 0.51 ) && (auxTDesgaste <= 0.74 )) {
            color="#FA4307"
            bandera=false
        }
        if (bandera && (auxTDesgaste >= 0.75 ) ) {
            color="#FF1744"        
        }

        return color
    }

    const registrarNvo = ( ) => {
        const idusu = localStorage.getItem('UsuId');
        const auxF=moment(inicio).format("YYYY-MM-DDTHH:mm:ss")
        const auxFMtto=moment(FMtto).format("YYYY-MM-DDTHH:mm:ss")
        const llenarNvoParo = () => {
            const data = qs.stringify({                              
                Usuario:idusu,
                Balancin:auxRegistro.Id,
                DetId:auxRegistro.TpDtId,
                FIni:auxF,
                TVida:TVida,
                HUso:HUso,
                Vuelta:Vuelta,
                Distancia:Distancia,
                Desgaste:Desgaste,
                EngFCambio:EngFCambio,
                EngNota:EngNota,
                FMtto:auxFMtto,
                Tecnico:Tecnico,
                idDispositivo: 'iu87ygubhjjij',
            });
            const url = "/pilona/balancin/mtto/v2/edit";
            let auxi = datos
           
            function respuesta(aux) {
                if (aux.respuesta === 1) {
                    let mensaje = "Se edito correctamente."
                    setTipoAdvertencia("success")
                    setMensaje(mensaje);
                    setAviso(true)
                    toast.success(mensaje, {
                        pauseOnFocusLoss: false, toastId: `edit-bal${aux.mensaje}`
                    })                  

                    const posicion = auxi.findIndex((element) => element.Id === auxRegistro.Id)
               
                    const arrEdit = {...auxRegistro, 
                        //Clase: "rodillo", EngFchCambio:"1900-01-01T00:00:00.000Z",RodFchCambio: "2026-06-15T22:08:48.603Z",Ord: 2, 
                        // Pilona: 1, ImgMini:"",ImgTotal: 3, EngNota: "", EngUsrCambio: "", Id:2,TpDtId: 69, RodUsrCambio: "Sistemas", 
                        FMtto:auxFMtto, RodDesgaste: Desgaste, RodDistancia: Distancia,  RodFchini: auxF,
                        RodHuso: HUso, RodTVida: TVida, RodVuelta: Vuelta, Tecnico: Tecnico,
                    }

                    setAuxRegistro(arrEdit)
                    auxi.splice(posicion, 1, arrEdit)
                    setDatos(auxi)

                    setModalAbierto(false)
                }
       
            }

            llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
        }
        llenarNvoParo();
    }

    const mostrarAlertas = (auxMensaje) => {
        setTipoAdvertencia("warning")
        let mensaje = auxMensaje
        setMensaje(mensaje);
        setAviso(true)
    }

    function valNulos(auxMensaje, auxCampo) {
        let valida = false
        if (auxCampo !== '' && auxCampo !== '0' && auxCampo !== 0 && auxCampo !== null && auxCampo !== " ") {
            valida = true
        }
        if (!valida) {
            mostrarAlertas(auxMensaje)
        }
        return valida
    }

    function valNulosNum(auxMensaje, auxCampo) {
        let valida = false
        if (auxCampo !== '' &&  auxCampo !== null && auxCampo !== " ") {
            valida = true
        }
        if (!valida) {
            mostrarAlertas(auxMensaje)
        }
        return valida
    }

    const guardarParo = () => {
        if (valNulosNum("Escribir Tiempo de Vida 1",TVida )//valNulos("Seleccionar Estatus", StatusId) 
            && valNulosNum("Escribir Hrs de Uso4",HUso )
            && valNulosNum("Escribir Vueltas 2", Vuelta)) 
        {
         
            setAviso(false)
            //let auxUbiNom = listUbic.filter((ubic) => ubic.value === parseInt(UbicId))
            registrarNvo()
            
        }
    };

    const onChange = e => {
        setRegistro({
            ...registro, [e.target.name]: e.target.value
        })
    };

    const onChangeNum = e =>
    { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');     
        let expCadena = new RegExp('[0-9]');
        if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
            !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
        {
        setRegistro({
            ...registro,
            [e.target.name] : e.target.value  
        })
        if (aviso) 
        {
            setMensaje('');
            setAviso(false);
        }
        }
    };

    const guardarFInicio = auxfecha => {
        setFechas({
            ...fechas,
            inicio: auxfecha
        })
    };

    const guardarFMtto = auxfecha => {
        setFechas({
            ...fechas,
            FMtto: auxfecha
        })
    };

    return (
    <ModalTam titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarParo}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} setAviso={setAviso} espera={espera}
        setEspera={setEspera} tamanio="md" btnDesact={false}
    >
        <form className={classes.root} noValidate autoComplete="off" fullWidth>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <Box mb={2}>
             
                    <Box mr={1} component="span">
                        <DateTimePicker
                            label="Fecha de Inicio " size={"small"} ampm={false}
                            value={inicio} style={{width: 10 + 'rem'}}
                            onChange={guardarFInicio}
                            minDate="2017-03-14" maxDate={new Date()}
                            format="dd/MM/yyyy HH:mm"   
                            cancelLabel={"Cancelar"} okLabel="Seleccionar"                                                              
                        />
                    </Box>
                
                    <TextField id="outlinedTvida"
                        label="Tiempo de Vida" size="small"
                        value={TVida} onChange={onChangeNum}
                        name="TVida" style={{width: 10 + 'rem'}}
                       InputProps={{ endAdornment: <InputAdornment position="end">Km</InputAdornment>}}
                    />
                  
                <TextField id="outlinedHUso"
                    label="Horas de Uso" size="small"
                    value={HUso} onChange={onChangeNum}
                    name="HUso" style={{width: 10 + 'rem', marginLeft:"1rem"}}
                    InputProps={{ endAdornment: <InputAdornment position="end">Hrs.</InputAdornment>}}
                />
                

            </Box>
            <Box mb={2}>
                <TextField id="outlinedVuelta"
                    label="Vueltas" size="small"
                    value={Vuelta} onChange={onChangeNum}
                    name="Vuelta" style={{width: 10 + 'rem'}}                    
                />
                <TextField id="outlinedDistancia"
                    label="Distancia" size="small" disabled={true}
                    value={Distancia} onChange={onChange}
                    name="Distancia" style={{width: 10 + 'rem', marginLeft:"1rem"}}
                     InputProps={{ endAdornment: <InputAdornment position="end">Km</InputAdornment>}}
                />
            </Box>
            <Box>
                 <Typography id="outlinedVuelta"
                    component="p" variant="body2" color='primary' 
                    style={{margin:0,marginBottom:.5+'rem', textAlign:"center", fontWeight:700,
                        backgroundColor:colorLeyenda, color:"white"}} 
                >   
                    {"Vida "}
                   <NumberFormat value= {auxTotVidal} displayType={'text'}  
                        thousandSeparator={true}
                    />

                    {txtLeyenda}
                </Typography>
            </Box>
           <DateTimePicker
                label="Fecha de Mantenimiento " size={"small"} ampm={false}
                value={FMtto} style={{width: '13rem'}}
                onChange={guardarFMtto}
                minDate="2017-03-14" maxDate={new Date()}
                format="dd/MM/yyyy HH:mm"   
                cancelLabel={"Cancelar"} okLabel="Seleccionar"                                                              
            />
            </MuiPickersUtilsProvider>
            <Box>
                <Typography component="p" variant="body2" color='primary' 
                    style={{margin:0,marginLeft:.5+'rem'}} >
                    Desgaste
                </Typography>  
                <textarea id="descripcion-input" name="Desgaste" rows="3" maxlength={2000}
                    cols="100" style={{width: 24 + "rem", borderRadius: 3 + 'px'}}
                    value={Desgaste} onChange={onChange} placeholder="Desgaste"
                />
            </Box>
            
            <TextField id="outlinedTecnico"
                label="Tecnico" size="small"
                value={Tecnico} onChange={onChange}
                name="Tecnico" style={{width:24  + 'rem'}}
            />
        </form>
    </ModalTam>);
}
